import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Spider extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                polar: true,
                type: 'line',
                width: 700,
                height: 550,
                marginRight: 120,
                marginLeft: 120,
            },
            xAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '10px',
                        fontWeight: '400',
                    },
                    distance: 25,
                },
                lineWidth: 0,
                tickmarkPlacement: 'on'
            },
            yAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '12px',
                        fontWeight: '400',
                    }
                },
                tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                lineWidth: 0,
                gridLineInterpolation: 'polygon',
                showLastLabel: true
            },
            plotOptions: {
                line: {
                    pointPlacement: 'on',
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Spider)}
